import { queryClient } from '@/shared/queries/query-client';
import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import type { MessagePinnedRes, PinnedMessage } from '../models/message-pinned';
import { fetchPinnedMessages } from '../services/message.service';
import { messageKeys } from './messsage-keys';

export const useMessagePinned = (conversationId: string, pageSize = 20) => {
  return useInfiniteQuery({
    queryKey: messageKeys.listPinned(conversationId),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchPinnedMessages({
        conversationId,
        pageSize,
        nextPageToken: pageParam
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextPageToken : undefined),
    enabled: !!conversationId,
    staleTime: 6000,
    retry: 1,
    refetchOnWindowFocus: false
  });
};

export const updatePinnedMessagesCache = (conversationId: string, newPinned: PinnedMessage) => {
  queryClient.setQueryData<InfiniteData<MessagePinnedRes>>(messageKeys.listPinned(conversationId), (oldData) => {
    if (!oldData) return oldData;

    const newPages = [...oldData.pages];
    const firstPage = { ...newPages[0] };

    // Remove if already exists to avoid duplicates
    firstPage.pinnedMessages = firstPage.pinnedMessages.filter(
      (p: PinnedMessage) => p.messageId !== newPinned.messageId
    );

    // Add the new pinned message to the top of the list
    firstPage.pinnedMessages = [newPinned, ...firstPage.pinnedMessages];
    firstPage.totalCount += 1;

    newPages[0] = firstPage;

    return { ...oldData, pages: newPages };
  });
};
